<template>
  <!-- 预约记录卡片 -->
  <div class="cardBox" v-for="item in data" :key="item.id">
    <itemTitle :datas="item">
      <div class="content">
        <template v-for="(rowObj, index) in item.list" :key="index">
          <rowItem :data="{ ...rowObj, span: labelSpan }" :rowClass="contentRow" :valueClass="valueClass" />
        </template>
      </div>
    </itemTitle>
  </div>
</template>

<script>
import { reactive, toRefs } from 'vue'
import rowItem from '@/components/oab/row'
import itemTitle from '@/components/oab/title'
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  components: {
    rowItem,
    itemTitle
  },
  emits: ['click', 'clickBtn'],
  setup(props, { emit }) {
    let { data } = toRefs(props)
    const state = reactive({
      data: data.value,
      contentRow: ['contentRow'],
      valueClass: ['valueClass'],
      labelSpan: 7
    })
    return {
      ...toRefs(state)
    }
  }
}
</script>
<style lang="scss" scoped>
.cardBox {
  background-color: #fff;
  text-align: left;
  font-size: 14px;
  color: #999;
  :deep(.valueClass) {
    display: inline-block;
    width: 100%;
    text-align: right;
  }
}
.content {
  padding: 20px 0;
}
.contentRow + .contentRow {
  margin-top: 12px;
}
</style>
